<template>
  <el-row :gutter="10"
          class="access-main">
    <el-col :span="5"
            :xs="24">
      <el-card shadow="none">
        <div slot="header">
          <span><i class="el-icon-discount mr-10"></i>门禁规则</span>
          <el-tooltip class="item"
                      effect="dark"
                      content="添加门禁规则"
                      placement="top"
                      style="float: right; padding: 3px 8px">
            <el-button v-has="'/pass_group/add'"
                       plain
                       type="primary"
                       @click="handleAdd">+</el-button>
          </el-tooltip>
        </div>
        <el-tree ref="groupTree"
                 default-expand-all
                 highlight-current
                 node-key="id"
                 :expand-on-click-node="false"
                 :current-node-key="currentKey"
                 :data="groupData"
                 :props="defaultProps"
                 @node-click="handleNodeClick">
          <span class="custom-tree-node"
                slot-scope="{ data }">
            <el-tooltip effect="dark"
                        :content="data.remark"
                        placement="top">
              <span>{{ data.name }}</span>
            </el-tooltip>
            <span>
              <el-button v-has="'/pass_group/edit'"
                         type="text"
                         size="mini"
                         icon="el-icon-edit"
                         @click.stop="() => editType(node, data)"></el-button>
              <el-button v-has="'/pass_group/del'"
                         type="text"
                         size="mini"
                         icon="el-icon-delete"
                         @click.stop="() => removeType(node, data)"></el-button>
            </span>
          </span>
        </el-tree>
      </el-card>
    </el-col>
    <el-col :span="19"
            :xs="24">
      <el-card shadow="none">
        <div slot="header">
          <el-button v-has="'/pass_rule/add'"
                     size="small"
                     type="primary"
                     @click="addItem">新增</el-button>
          <el-button v-has="'/pass_rule/batch_del'"
                     size="small"
                     type="primary"
                     @click="multipleDelete">批量删除</el-button>
        </div>
        <el-table max-height="605"
                  :data="tableData"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection"
                           width="80"></el-table-column>
          <el-table-column v-for="(item, index) in tableTitle"
                           :key="index"
                           :label="item.name"
                           :prop="item.prop"
                           :min-width="item.width"
                           :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column label="操作"
                           width="150">
            <template slot-scope="scope">
              <el-button v-has="'/pass_rule/edit'"
                         size="mini"
                         type="primary"
                         @click="editItem(scope.row)">编辑</el-button>
              <el-button v-has="'/pass_rule/batch_del'"
                         size="mini"
                         type="danger"
                         @click="handleDelete(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <Pagination :total="pagination.total"
                    :current="pagination.currentPage"
                    :pageSize="pagination.perPage"
                    @handleSizeChange="handleSizeChange"
                    @handleCurrent="handleCurrentChange"></Pagination>
      </el-card>
    </el-col>
    <add-group v-if="showAddModal"
               :isShow="showAddModal"
               :data="addData"
               @handleClose="closeAddModal"></add-group>
    <add-rule v-if="showItemModal"
              :isShow="showItemModal"
              :data="itemData"
              @handleClose="closeItemModal"></add-rule>
  </el-row>
</template>

<script>
import fetch from '@/common/api'
import AddGroup from '@/views/humanResources/access/AddGroup'
import AddRule from '@/views/humanResources/access/AddRule'
import Pagination from '@/components/pagination/Pagination'
export default {
  components: { AddGroup, Pagination, AddRule },
  data() {
    return {
      currentKey: '',
      groupData: [],
      defaultProps: {
        label: 'label',
        children: 'children'
      },
      tableTitle: [
        {
          prop: 'lock_name',
          name: '设备名称',
          width: '100'
        },
        {
          prop: 'room_name',
          name: '房间',
          width: '100'
        },
        {
          prop: 'area_names',
          name: '区域',
          width: '100'
        },
        {
          prop: 'slot_name',
          name: '时间组',
          width: '100'
        }
      ],
      tableData: [],
      // 分页相关
      pagination: {
        total: 0,
        currentPage: 1,
        perPage: 10
      },
      // 选中数据
      multipleSelection: [],
      // 添加组
      showAddModal: false,
      addData: {},
      // 添加规则
      showItemModal: false,
      itemData: {}
    }
  },
  created() {
    this.getPassGroupList().then(() => {
      this.getList()
    })
  },
  methods: {
    // 获取门禁组
    getPassGroupList() {
      return Promise.resolve(
        fetch.getPassGroupList({}).then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.groupData = data.list
              this.currentKey = data.list[0].id
              this.$nextTick(function () {
                this.$refs.groupTree.setCurrentKey(data.list[0].id)
              })
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
      )
    },
    // 获取门禁规则
    getList() {
      return Promise.resolve(
        fetch.getPassRuleList({ group_id: this.currentKey }).then((data) => {
          data.procData(
            data.res,
            (data) => {
              this.pagination.total = Number(data.total)
              this.tableData = data.list
            },
            (err) => {
              this.$message.error(err)
            }
          )
        })
      )
    },
    handleNodeClick(data) {
      this.currentKey = data.id
      this.getList()
    },
    handleChange(value, data) {
      console.log(value)
      console.log(data)
    },
    // 选择变化
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    // 分页
    handleSizeChange(val) {
      this.pagination.perPage = val
      this.pagination.currentPage = 1
      this.getList()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getList()
    },
    // 添加组
    handleAdd() {
      this.showAddModal = true
      this.addData = {
        type: 'add'
      }
    },
    // 编辑字典类型
    editType(node, data) {
      this.showAddModal = true
      this.addData = {
        type: 'edit',
        id: data.id
      }
    },
    // 关闭添加组
    closeAddModal(type) {
      if (type === 'refresh') {
        this.getPassGroupList()
      }
      this.showAddModal = false
    },
    // 添加具体类目
    addItem() {
      this.showItemModal = true
      this.itemData = {
        pId: this.currentKey,
        type: 'add'
      }
    },
    // 编辑类目
    editItem(data) {
      this.showItemModal = true
      this.itemData = {
        pId: this.currentKey,
        type: 'edit',
        id: data.id
      }
    },
    // 关闭添加类目弹窗
    closeItemModal(params) {
      if (params === 'refresh') {
        this.getList()
      }
      this.showItemModal = false
    },
    // 删除组
    removeType(node, data) {
      this.$confirm('是否确定删除该数据类型?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          fetch.delPassGroup({ id: data.id }).then((data) => {
            data.procData(
              data.res,
              () => {
                this.getPassGroupList()
                this.$message.success('操作成功')
              },
              (err) => {
                this.$message.error(err)
              }
            )
          })
        })
        .catch(() => {})
    },
    // 删除
    handleDelete(data) {
      this.$confirm('是否确定删除选中的数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.delPassRule(data.id)
        })
        .catch(() => {})
    },
    // 批量删除
    multipleDelete() {
      if (this.multipleSelection.length > 0) {
        this.$confirm('是否确定删除选中的数据?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            let selectIds = this.multipleSelection
              .map((item) => {
                return item.id
              })
              .join(',')
            this.delPassRule(selectIds)
          })
          .catch(() => {})
      } else {
        this.$message.warning('请选择房型后重试')
      }
    },
    // 删除规则
    delPassRule(ids) {
      fetch.batchDelPassRule({ id: ids }).then((data) => {
        data.procData(
          data.res,
          () => {
            this.getList()
            this.$message.success('操作成功')
          },
          (err) => {
            this.$message.error(err)
          }
        )
      })
    }
  }
}
</script>

<style lang="less">
.access-main {
  .el-tree {
    .el-tree-node__content {
      height: 40px;
    }
    .custom-tree-node {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 14px;
      padding-right: 8px;
    }
  }
}
</style>
